import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { TextArea, Input } from 'design-react-kit';
import {
  checkValidEmail,
  checkValidCF,
} from '@redturtle/volto-io-prenoto/helpers';

/* STYLE */
import '@redturtle/volto-io-prenoto/components/View/Commons/InputFieldsSchema/InputFieldsSchema.scss';

const messages = defineMessages({
  no_valid_email: {
    id: 'no_valid_email',
    defaultMessage: 'E-mail non valida',
  },
  no_valid_cf: {
    id: 'no_valid_cf',
    defaultMessage: 'Codice fiscale non valido',
  },
});

const InputFieldsSchema = ({
  schema,
  additionalFields,
  operatorArea = false,
  getFieldValue,
  changeField,
}) => {
  const intl = useIntl();

  // Input label and validation: email e codice fiscale
  const [emailInputLabel, setEmailInputLabel] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(true);

  const [CFInputLabel, setCFInputLabel] = useState('');
  const [isValidCF, setIsValidCF] = useState(true);

  /* Check an invalid format email */
  const focusOutInputEmail = (value) => {
    if (checkValidEmail(value) || value === '') {
      setIsValidEmail(true);
      setEmailInputLabel('');
    } else {
      setIsValidEmail(false);
      setEmailInputLabel(intl.formatMessage(messages.no_valid_email));
    }
  };

  /* Check an invalid format CF */
  const focusOutInputCF = (value) => {
    if (checkValidCF(value) || value === '') {
      setIsValidCF(true);
      setCFInputLabel('');
    } else {
      setIsValidCF(false);
      setCFInputLabel(intl.formatMessage(messages.no_valid_cf));
    }
  };

  return (
    <>
      {schema.length > 0 &&
        schema
          .filter((s) => s.name != 'description')
          .map((field, index, { length }) => {
            return (
              <React.Fragment key={field.name}>
                {/* COMMON INPUT TEXT */}
                {field.type !== 'textarea' &&
                  field.name !== 'email' &&
                  field.name !== 'fiscalcode' && (
                    <span key={field.name}>
                      <Input
                        type={field.type}
                        label={field.required ? field.label + '*' : field.label}
                        aria-label={
                          field.required ? field.label + '*' : field.label
                        }
                        name={field.name}
                        value={getFieldValue(field.name)}
                        readOnly={field.readonly && !operatorArea} // se si è nell'area Operatore, deve poter inserire anche i dati readOnly
                        required={field.required}
                        infoText={field.desc}
                        onChange={(e) =>
                          changeField(field.name, e.target.value)
                        }
                        // className={
                        //   index + 1 === length && operatorArea ? 'mb-0' : ''
                        // }
                      />
                    </span>
                  )}
                {/* EMAIL INPUT */}
                {field.name === 'email' && (
                  <span key={field.name}>
                    <Input
                      type={field.name}
                      label={
                        (!emailInputLabel ? field.label : emailInputLabel) +
                        (field.required ? '*' : '')
                      }
                      aria-label={
                        (!emailInputLabel ? field.label : emailInputLabel) +
                        (field.required ? '*' : '')
                      }
                      name={field.name}
                      value={getFieldValue(field.name)}
                      readOnly={field.readonly && !operatorArea} // se si è nell'area Operatore, deve poter inserire anche i dati readOnly
                      required={field.required}
                      infoText={field.desc}
                      invalid={!isValidEmail}
                      onBlur={(e) => focusOutInputEmail(e.target.value)}
                      onChange={(e) => changeField(field.name, e.target.value)}
                      className={
                        index + 1 === length && operatorArea ? 'mb-0' : ''
                      }
                    />
                  </span>
                )}
                {/* CF INPUT */}
                {field.name === 'fiscalcode' && (
                  <span key={field.name}>
                    <Input
                      type={field.type}
                      label={
                        (!CFInputLabel ? field.label : CFInputLabel) +
                        (field.required ? '*' : '')
                      }
                      aria-label={
                        (!CFInputLabel ? field.label : CFInputLabel) +
                        (field.required ? '*' : '')
                      }
                      name={field.name}
                      value={getFieldValue(field.name)}
                      readOnly={field.readonly && !operatorArea} // se si è nell'area Operatore, deve poter inserire anche i dati readOnly
                      required={field.required}
                      infoText={field.desc}
                      invalid={!isValidCF}
                      onBlur={(e) => focusOutInputCF(e.target.value)}
                      onChange={(e) => changeField(field.name, e.target.value)}
                      className={
                        index + 1 === length && operatorArea ? 'mb-0' : ''
                      }
                    />
                  </span>
                )}
                {/* TEXTAREA INPUT */}
                {field.type === 'textarea' && (
                  <span key={field.name}>
                    <TextArea
                      className={
                        'border-top-0 border-end-0 border-start-0 ' +
                        (index + 1 === length && operatorArea ? 'mb-0' : '')
                      }
                      rows={2}
                      label={field.required ? field.label + '*' : field.label}
                      aria-label={
                        field.required ? field.label + '*' : field.label
                      }
                      value={getFieldValue(field.name)}
                      infoText={field.desc}
                      readOnly={field.readonly && !operatorArea} // se si è nell'area Operatore, deve poter inserire anche i dati readOnly
                      required={field.required}
                      onChange={(e) => changeField(field.name, e.target.value)}
                    />
                  </span>
                )}
              </React.Fragment>
            );
          })}
      {additionalFields &&
        additionalFields.length > 0 &&
        additionalFields.map(
          (field) =>
            field.type === 'text' && (
              <span key={field.name}>
                <Input
                  type={field.type}
                  label={field.required ? field.label + '*' : field.label}
                  aria-label={field.required ? field.label + '*' : field.label}
                  name={field.name}
                  value={getFieldValue(field.name)}
                  required={field.required}
                  infoText={field.description}
                  onChange={(e) => changeField(field.name, e.target.value)}
                />
              </span>
            ),
        )}
    </>
  );
};
export default InputFieldsSchema;
